import { Trash2 } from 'lucide-react'
import { useState } from 'react'
import { Button } from '~/components/ui/button'
import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogFooter,
    DialogHeader,
    DialogTitle,
    DialogTrigger,
} from '~/components/ui/dialog'
import { Loading } from '~/components/ui/loading'
import { useDeleteEmployeeMutation } from '~/hooks/admin/funcionarios'
import type { User } from '~/types/user'

interface DeleteEmployeeDialogProps {
    employee: User
}

export function DeleteEmployeeDialog({ employee }: DeleteEmployeeDialogProps) {
    const [isOpen, setIsOpen] = useState(false)
    const { deleteEmployee, isPending: isDeleting } = useDeleteEmployeeMutation()

    const handleDelete = async () => {
        await deleteEmployee(employee.id)
        setIsOpen(false)
    }

    return (
        <Dialog open={isOpen} onOpenChange={setIsOpen}>
            <DialogTrigger asChild>
                <Button variant="ghost" className="flex items-center gap-2 text-red-600 hover:text-red-700">
                    <Trash2 className="size-4" />
                </Button>
            </DialogTrigger>
            <DialogContent>
                <DialogHeader>
                    <DialogTitle>Excluir Funcionário</DialogTitle>
                    <DialogDescription className='text-md text-center p-4'>
                        Tem certeza de que deseja excluir o funcionário <strong>{employee.name}</strong>?
                        Esta ação não pode ser desfeita e o funcionário será desativado do sistema.
                    </DialogDescription>
                </DialogHeader>
                <DialogFooter>
                    <Button
                        variant="outline"
                        onClick={() => setIsOpen(false)}
                        disabled={isDeleting}
                    >
                        Cancelar
                    </Button>
                    <Button
                        variant="destructive"
                        onClick={handleDelete}
                        disabled={isDeleting}
                    >
                        {isDeleting && <Loading className="w-4 h-4 mr-2" />}
                        Excluir
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    )
}
